module.exports = __webpack_public_path__ + "static/img/icon-part2-3.dd0de8b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icon-part2-3.png
// module id = BLxk
// module chunks = 1